import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
import { fromPickadate, now, toFormattedString
// @ts-expect-error: no types
} from 'UIComponents/core/SimpleDate';
import { getContentPrivateRegistrationListIds, getContentType, getIsBlogPost, getNonCrmPropertyValue } from 'framework-asset-preview-lib/internal/objectTypes/0-10/utils';
import { getPropertyValue } from 'framework-asset-preview-lib/internal/shared/utils/crmObject';
import { OBJECT_TYPE } from 'framework-asset-preview-lib/internal/shared/constants/objectTypes';
import { fetchCrmObjects } from 'framework-asset-preview-lib/internal/shared/api/crm';
import cachedHttp from 'framework-asset-preview-lib/internal/shared/api/cachedHttp';
const ANALYTICS_DATE_FORMAT = 'YYYYMMDD';

/**
 * We use the same request payload to fetch for all content objects.
 */
function getContentFetchParams(contentId) {
  return {
    count: 1,
    filterGroups: [{
      filters: [{
        operator: 'EQ',
        property: 'hs_content_id',
        value: `${contentId}`
      }]
    }],
    objectTypeId: 'content',
    offset: 0,
    requestOptions: {
      allPropertiesFetchMode: 'latest_version',
      includeAllProperties: true
    },
    query: '',
    sorts: []
  };
}
export function fetchContentDetails(crmObject) {
  const contentIdProperty = crmObject.objectTypeId === OBJECT_TYPE.CONTENT ? 'hs_content_id' : 'hs_origin_asset_id';
  const contentId = getPropertyValue(crmObject, contentIdProperty);
  const contentType = getContentType(crmObject);
  const url = getIsBlogPost(crmObject) ? '/blogs/v3/blog-posts/crm-search/search' : `/cospages/v2/dashboard/${contentType}-pages/crm-search/search`;
  return http.post(url, {
    data: getContentFetchParams(`${contentId}`)
  }).then(response => response.objects.length ? response.objects[0] : undefined);
}
export function fetchBlogPostDetails(crmObject) {
  const contentId = getPropertyValue(crmObject, 'hs_origin_asset_id');
  return http.post('/blogs/v3/blog-posts/crm-search/search', {
    data: getContentFetchParams(`${contentId}`)
  }).then(response => response.objects.length ? response.objects[0] : undefined);
}
export function fetchLandingPageDetails(crmObject) {
  const contentId = getPropertyValue(crmObject, 'hs_origin_asset_id');
  return http.post('/cospages/v2/dashboard/landing-pages/crm-search/search', {
    data: getContentFetchParams(`${contentId}`)
  }).then(response => response.objects.length ? response.objects[0] : undefined);
}
export function fetchSitePageDetails(crmObject) {
  const contentId = getPropertyValue(crmObject, 'hs_origin_asset_id');
  return http.post('/cospages/v2/dashboard/site-pages/crm-search/search', {
    data: getContentFetchParams(`${contentId}`)
  }).then(response => response.objects.length ? response.objects[0] : undefined);
}
export function getTemplatePath(postTemplateOrTemplatePath) {
  return cachedHttp.get(`designmanager/v1/templates/by-path/${postTemplateOrTemplatePath}`);
}
export function getPortalSettings() {
  return cachedHttp.get(`content-settings/v1/site-settings/by-portal-id/${PortalIdParser.get()}`);
}
export function getFormsUsed(contentId) {
  return cachedHttp.get('cosindex/api/v1/connections/children', {
    query: {
      childType: 'FORM',
      fields: 'BASIC',
      id: contentId,
      levels: 0
    }
  });
}
export function getFormsUsedAsCrmObjects(contentId) {
  return getFormsUsed(contentId).then(forms => {
    const formIds = forms.map(form => form.id);
    return fetchCrmObjects(OBJECT_TYPE.FORM, {
      filterGroups: [{
        filters: [{
          operator: 'IN',
          property: 'hs_form_id',
          values: formIds.map(formId => String(formId))
        }]
      }]
    }).then(response => response.results);
  });
}
export function getAdaptiveExperiments(crmObject, nonCrmObject) {
  const contentType = getContentType(crmObject);
  const mabExperimentId = getNonCrmPropertyValue('mabExperimentId', nonCrmObject);
  return cachedHttp.get(`cospages/v2/${contentType}-pages/mab-get-experiment/${mabExperimentId}`);
}
export function getAbTestVariations(crmObject, nonCrmObject) {
  const contentType = getContentType(crmObject);
  const hsAbTestId = getNonCrmPropertyValue('abTestId', nonCrmObject);
  return cachedHttp.get(`cospages/v2/${contentType}-pages`, {
    query: {
      abTestId: hsAbTestId,
      property: ['id', 'name']
    }
  });
}
export function getAudienceAccess(nonCrmObject) {
  const privateRegistrationListIds = getContentPrivateRegistrationListIds(nonCrmObject);
  if (!Array.isArray(privateRegistrationListIds) || privateRegistrationListIds.length === 0) {
    const response = {
      lists: []
    };
    return Promise.resolve(response);
  }
  return http.post(`contacts/v1/lists/batch`, {
    data: privateRegistrationListIds
  });
}
export function fetchContentStatistics(crmObject) {
  const startDate = fromPickadate({
    year: 2006,
    month: 0,
    date: 1
  });
  const contentIdProperty = crmObject.objectTypeId === OBJECT_TYPE.CONTENT ? 'hs_content_id' : 'hs_origin_asset_id';
  return cachedHttp.get(`activities/v2/reports/all-pages-sources/total`, {
    query: {
      end: toFormattedString(now(), ANALYTICS_DATE_FORMAT),
      offset: 0,
      pageId: getPropertyValue(crmObject, contentIdProperty),
      start: toFormattedString(startDate, ANALYTICS_DATE_FORMAT),
      useForeignIndex: false
    }
  });
}